'use client'

import type { MouseEvent } from 'react'

import { Anchor } from '@/components/client/seo/anchor'

export const ArticleCitationLink = ({ id, number }: { id: string; number: number }) => {
  const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return
    }
    const target = document.getElementById(id)
    if (target) {
      // The nav hides on downward scroll. Its fixed clearance otherwise puts
      // earlier compact references at the top. Upward jumps and no-JS links
      // retain clearance for the visible nav. Let the native fragment link
      // handle the hash, history and focus.
      target.style.scrollMarginTop = target.getBoundingClientRect().top > 112 ? '24px' : '112px'
    }
  }
  return (
    <Anchor href={`#${id}`} data-citation-id={id} data-tracking="ignore" onClick={onClick}>
      {number}
    </Anchor>
  )
}
